<script>
import { Model } from '@vuex-orm/core'
import _includes from 'lodash/includes'
import _get from 'lodash/get'
export default {
  name: 'WithEntity',
  props: {
    Model: {
      type: Model,
      default: () => Model,
    },
    id: {
      type: [String, Number],
      required: true,
      default: undefined,
    },
    viewType: {
      type: String,
      default: 'index',
      validator: (v) => _includes(['index', 'detail'], v),
    },
  },
  data() {
    return {
      loading: false,
      error: null,
    }
  },
  methods: {
    async fetch() {
      let foundEntity = await this.Model.find(this.id)
      if (foundEntity) return
      if (_get(this.theEntity, '$isNew')) return
      this.loading = true
      try {
        await this.Model.fetchById(this.id)
      } catch (error) {
        this.error = error
        throw Error(error)
      } finally {
        this.loading = false
      }
    }, // fetch
  },
  computed: {
    theEntity() {
      const queryId = isNaN(this.id) ? this.id : Number(this.id)
      return this.Model
        ? this.Model.query()
            .whereId(queryId)
            .with(
              this.Model.detail_query_with ? this.Model.detail_query_with() : ''
            )
            .first()
        : null
    }, // theEntity
    headers() {
      if (this.viewType === 'detail') {
        return this.Model.field_headers
          ? this.Model.field_headers().filter(
              (h) => !_get(h, 'hideOnDetail', false)
            )
          : []
      }
      return this.Model.field_headers
        ? this.Model.field_headers().filter(
            (h) => !_get(h, 'hideOnIndex', false)
          )
        : []
    },
  },
  watch: {
    id: {
      handler() {
        this.fetch()
      },
      immediate: true,
    },
  },
  render() {
    return this.$scopedSlots.default({
      loading: this.loading,
      headers: this.headers,
      entity: this.theEntity,
    })
  },
}
</script>
